import type { TextBox, } from "client/store/features/memeGenerator/types";

export const isTextBoxDragging = (textBox: TextBox) =>
    !!textBox.draggingState?.resize || !!textBox.draggingState?.rotate || !!textBox.draggingState?.position;
